import { request } from "@/utils/request";

/**
 * 知识产权备案查询接口
 * @param {Object} params 查询参数
 * @param {string} params.query 查询条件（待审核/审核通过/审核驳回/未到账/审核中）
 * @returns {Promise} 返回Promise对象
 */
export function getIntellectualPropertyRecords(params) {
    return request("/brand/query", "post", params);
}

export function queryExact(params) {
    return request("/brand/queryExact", "post", params);
}
